export default __webpack_public_path__ + "static/media/img_option_c.c9e9393a.svg";